export default "__VITE_ASSET__B4QTX7Pq__"